import StepFirst from "../assets/onboarding/step-1.webp";
import StepFirst2x from "../assets/onboarding/step-1@2x.webp";
import StepFirst3x from "../assets/onboarding/step-1@3x.webp";
import StepSecond from "../assets/onboarding/step-2.webp";
import StepSecond2x from "../assets/onboarding/step-2@2x.webp";
import StepSecond3x from "../assets/onboarding/step-2@3x.webp";
import StepThird from "../assets/onboarding/step-3.webp";
import StepThird2x from "../assets/onboarding/step-3@2x.webp";
import StepThird3x from "../assets/onboarding/step-3@3x.webp";
import StepFourth from "../assets/onboarding/step-4.webp";
import StepFourth2x from "../assets/onboarding/step-4@2x.webp";
import StepFourth3x from "../assets/onboarding/step-4@3x.webp";

export const ONBOARDING_SLIDES = [
  {
    title: "onboarding_slide_1_title",
    description: "onboarding_slide_1_desc",
    image: {
      oneX: StepFirst,
      twoX: StepFirst2x,
      threeX: StepFirst3x,
    },
  },
  {
    title: "onboarding_slide_2_title",
    description: "onboarding_slide_2_desc",
    image: {
      oneX: StepSecond,
      twoX: StepSecond2x,
      threeX: StepSecond3x,
    },
  },
  {
    title: "onboarding_slide_3_title",
    description: "onboarding_slide_3_desc",
    image: {
      oneX: StepThird,
      twoX: StepThird2x,
      threeX: StepThird3x,
    },
  },
  {
    title: "onboarding_slide_4_title",
    description: "onboarding_slide_4_desc",
    image: {
      oneX: StepFourth,
      twoX: StepFourth2x,
      threeX: StepFourth3x,
    },
  },
];
